import Typography from '@components/common/typography';
import { IModalComponentProps } from '@context/modal_context';
import { FC } from 'react';
import styles from './styles.module.scss';

const CancelGiftCardModal: FC<IModalComponentProps<{ isBulk: boolean }>> = ({
    modalData: { isBulk }
}) => {
    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                {isBulk ? 'Cancel gift cards' : 'Cancel gift card'}
            </Typography>
            <Typography variant="body3" alignment="center">
                {isBulk
                    ? 'Are you sure you want to cancel these gift cards? This action cannot be undone.'
                    : 'Are you sure you want to cancel this gift card? This action cannot be undone.'}
            </Typography>
        </div>
    );
};

export default CancelGiftCardModal;
